import cn from "classnames";
import { useColorProps } from "../../../hooks";
import { ButtonProps } from "../Button";

export const useButtonProps = (props: ButtonProps) => {
  // Remove button props from list to prevent passing down.
  const {
    className,
    close,
    disabled,
    ghost,
    large,
    link,
    loading,
    outline,
    pill,
    small,
    square,
    ...rest
  } = useColorProps(props, "btn");

  // Create the new className with button classes added to existing class names.
  const output: string = cn(
    "btn",
    {
      [`btn-outline-${props.color}`]: outline,
      [`btn-ghost-${props.color}`]: ghost,
      "btn-close": close,
      "btn-link": link,
      "btn-square": square,
      "btn-pill": pill,
      "btn-sm": small,
      "btn-lg": large,
      "btn-icon": props.icon && !props.text,
      "btn-loading": loading,
      disabled: disabled,
    },
    className
  );

  // return the updated props;
  return { className: output, ...rest };
};
